import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuroraBackground from '../components/AuroraBackground/AuroraBackground';
import AuroraNavbar from '../components/AuroraNavbar/AuroraNavbar';
import Footer from '../components/Footer';
import MetaHead from '../components/MetaHead';
import '../styles/pg-legal.css';

// Squelette structuré. À compléter avec les termes définitifs de Contrat_Revyo_v2.docx
// avant signature d'un premier contrat commercial.
// i18n P4 : strings extraites vers legal.json. Disclaimer "version FR fait foi" affiché
// sur EN/ES/IT pour valeur juridique (version FR seule légalement contraignante en V1).
export default function CGV() {
  const { t, i18n } = useTranslation('legal');
  const isFrench = i18n.language === 'fr';

  return (
    <>
      <MetaHead page="legal_cgv" />
      <AuroraBackground dim />
      <AuroraNavbar />

      <main className="pg-legal">
        <h1 className="pg-legal-h1">{t('cgv.title')}</h1>
        <div className="pg-legal-updated">{t('cgv.last_update')}</div>

        <div className="pg-legal-note">
          {t('cgv.provisional_note_prefix')}{' '}
          <a href="mailto:contact@getrevyo.com">contact@getrevyo.com</a>.
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_1_title')}</h2>
          <p>{t('cgv.section_1_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_2_title')}</h2>
          <p>
            {t('cgv.section_2_body_part1')}{' '}
            <Link to="/tarifs" className="pg-legal-link">{t('cgv.section_2_pricing_link')}</Link>
            {t('cgv.section_2_body_part2')}
          </p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_3_title')}</h2>
          <p>{t('cgv.section_3_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_4_title')}</h2>
          <p>{t('cgv.section_4_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_5_title')}</h2>
          <p>{t('cgv.section_5_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_6_title')}</h2>
          <p>{t('cgv.section_6_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_7_title')}</h2>
          <p>
            {t('cgv.section_7_body_part1')}{' '}
            <Link to="/politique-de-confidentialite" className="pg-legal-link">{t('cgv.section_7_privacy_link')}</Link>
            {t('cgv.section_7_body_part2')}
          </p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_8_title')}</h2>
          <p>{t('cgv.section_8_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_9_title')}</h2>
          <p>{t('cgv.section_9_body')}</p>
        </div>

        <div className="pg-legal-card">
          <h2 className="pg-legal-h2">{t('cgv.section_10_title')}</h2>
          <p>{t('cgv.section_10_body')}</p>
        </div>

        {/* Disclaimer "version FR fait foi" — affiché uniquement en EN/ES/IT.
            Garantit la valeur juridique des CGV originales en cas de divergence. */}
        {!isFrench && (
          <div className="pg-legal-disclaimer">{t('common.disclaimer_translation')}</div>
        )}
      </main>

      <Footer />
    </>
  );
}
